// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34xhz","col":"styles_col__2n3R4"};